<script>
import { mapState, mapActions } from 'vuex';
/* tools */
import {} from '@/scripts/utils';

export default {
  name: 'InputBlock',
  props: {
    type: {
      type: String,
      default: 'text',
    },
    placeholder: {
      type: String,
      default: '',
    },
    forceValue: {
      type: String,
      default: '',
    },
    error: {
      type: String,
      default: '',
    },
    tabindex: {
      type: String,
      default: '',
    },
    autofocus: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {};
  },
  computed: {
    ...mapState(['user']),
  },
  created() {},
  mounted() {},
  methods: {
    ...mapActions({}),
    atInput(val) {
      this.$emit('input', val);
    },
  },
};
</script>

<template>
  <div class="input-block">
    <div class="input-block__label" v-if="$slots.label">
      <slot name="label" />
    </div>
    <div :class="{ 'input-block__wrapper': true, error: error }">
      <input
        @input="atInput($event.target.value)"
        @keyup.enter="$emit('enter')"
        class="input"
        :value="forceValue"
        :type="type"
        :placeholder="placeholder"
        :autofocus="autofocus"
        :tabindex="tabindex"
      />
      <div class="input-block__error">
        {{ error }}
      </div>
      <div class="input-block__link-bottom" v-if="$slots.linkBottom">
        <slot name="linkBottom" />
      </div>
      <div class="input-block__link-top" v-if="$slots.linkTop">
        <slot name="linkTop" />
      </div>
      <div class="input-block__btn-show" v-if="$slots.btnShow">
        <slot name="btnShow" />
      </div>
    </div>
  </div>
</template>

<style scoped lang="scss">
@import '@/styles/variables.scss';

.input-block {
  width: 100%;
  position: relative;

  &__wrapper {
    width: 100%;
    position: relative;

    &.error {
      .input-block__error {
        opacity: 1;
        visibility: visible;
      }

      .input {
        border-color: #f95862;
      }
    }
  }

  &__link-bottom {
    position: absolute;
    right: 0;
    top: 100%;
    margin-top: 15px;
    z-index: 1;
    text-align: right;
  }

  &__link-top {
    position: absolute;
    right: 0;
    bottom: 100%;
    margin-bottom: 15px;
    z-index: 1;
    text-align: right;
  }

  &__error {
    position: absolute;
    top: 100%;
    left: 0;
    margin-top: 15px;
    font-family: Poppins-Light;
    font-size: 14px;
    line-height: 20px;
    color: #f95862;
    opacity: 0;
    visibility: hidden;
    transition: all 0.2;
    width: 100%;
    padding-right: 90px;
    text-align: left;
  }

  &__label {
    font-family: Poppins-Regular;
    font-size: 14px;
    line-height: 20px;
    color: #ffffff;
    margin-bottom: 15px;
    text-align: left;
  }

  &.error-relative {
    .input-block__error {
      position: relative;
    }
  }

  &.disabled-points {
    .input {
      user-select: none;
      pointer-events: none;
    }
  }

  &__btn-show {
    position: absolute;
    right: 17px;
    top: 50%;
    transform: translateY(-50%);
  }
}

.input {
  height: 44px;
  border-radius: 8px;
  border: solid 1px rgba(255, 255, 255, 0.2);
  background-color: rgba(255, 255, 255, 0.1);
  color: #ffffff;
  padding: 8px 15px;
  font-family: Poppins-Regular;
  font-size: 14px;
  line-height: 17px;
  outline: none;
  width: 100%;
  transition: border-color 0.2s;

  &.disabled-points {
    user-select: none;
    pointer-events: none;
  }

  &:placeholder {
    height: inherit;
    line-height: inherit;
  }
}

/* mobile */
@media (max-width: $mobile) {
  .input-block {
    &__label {
      font-size: 12px;
      line-height: 17px;
      color: rgba(255, 255, 255, 0.7);
    }
  }
}
</style>
